import { all, takeLatest } from 'redux-saga/effects'
import { assignEmployeeToTLSaga, changePasswordSaga, createEmergencyContactSaga, fetchEmployeeProfileSaga, fetchMyProfileSaga, fetchUserDashboardSaga, fetchUserProfileSaga, forceResetPasswordSaga, getAllConversationMessagesSaga, getAllConversationsUsersSaga, listAttendanceSaga, listEmployeeSaga, listUserSaga, listUsersForConversationSaga, loginUserSaga, resetPasswordSaga, updateEmergencyContactSaga, updateEmployeeProfileSaga, updateMyProfilePictureSaga, updateUserSaga } from './sagas/userSaga'
import { changeMyProfilePicture, changePassword, createEmergencyContact, forceResetPassword, getMyProfile, login, resetPassword, updateEmergencyContact, updateMyProfile } from '../redux/slices/userSlice'
import { assignEmployeeToTL, createEmployee, employeeLeave, fetchAllConversationUsers, fetchAllMessagesUsers, fetchAllUserConversationList, getAttendanceList, getEmployeeLeave, getEmployeeLeaveBalance, getEmployeeList, getEmployeeProfile, getUserDashboard, getUserList, getUserProfile, reopenAttendance, updateEmployee, updateEmployeeLeave, updateUser } from '../redux/slices/adminListSlice'
import { createEmployeeLeaveSaga, createEmployeeSaga, getEmployeeLeaveSaga, updateEmployeeLeaveSaga, updateEmployeeSaga } from './sagas/employeeSaga'
import { closeAttendance, closeBreak, createAttendance, createBreak, generateMonthlyReport, listMyAttendance, todayAttendance, updateAttendanceTime, updateBreakTime } from '../redux/slices/attendanceSlice'
import { closeBreakSaga, closeTodayAttendanceSaga, createAttendanceSaga, createBreakSaga, generateMonthlyReportSaga, getTodayAttendanceSaga, listMyAttendanceSaga, reopenAttendanceSaga, updateAttendanceTimeSaga, updateBreakSaga } from './sagas/attendanceSaga'
import { createAquirer, createBusinessDescription, createBusinessType, createTerminalModel, createTerminalType, fetchDropdown, getAddress, getBusinessDescription, getBusinessType, getFinalAddress, listAquirer, listTerminalModel, listTerminalType } from '../redux/slices/commonDropdownSlice'
import { addAquirerSaga, addTerminalModelSaga, addTerminalTypeSaga, addressLookupSaga, businessDescriptionSaga, businessTypeSaga, countryDropdownSaga, getAddressSaga, getAquirerSaga, getTerminalModelSaga, getTerminalTypeSaga, listDescriptionSaga, listTypeSaga } from './sagas/commonDropdownSaga'
import { addIp, createCalendarEvent, createShift, deleteCalendarEvent, getCalendarEvent, getCurrentIp, getRangeEvents, listIp, listShifts, removeIp, updateCalendarEvent, updateIp, updateShift } from '../redux/slices/organizationSlice'
import { addIpSaga, addShiftSaga, createCalendarSaga, deleteCalenderSaga, deleteIpSaga, getAllCalendarRangeSaga, getAllCalendarSaga, getAllIpSaga, getAllShiftSaga, getCurrentIpSaga, toggleIpSaga, udpateShiftSaga, updateCalenderSaga } from './sagas/organizationSaga'
import { assignNewUser, createApplication, createNotes, fetchLogs, fetchNotes, getSingleApplication, getStatusCount, listApplication, saveApplication, updateApplication, updateApplicationStatus } from '../redux/slices/applicationSlice'
import { applicationStatusCountSaga, assignNewUserSaga, createApplicationSaga, createNotesSaga, fetchLogsSaga, fetchNotesSaga, fetchSingleApplicationSaga, listApplicationSaga, saveApplicationSaga, updateApplicationSaga, updateApplicationStatusSaga } from './sagas/applicationSaga'
import { createPerson } from '../redux/slices/personSlice'
import { createPersonSaga } from './sagas/personSaga'
import { createProspects, getAllProspectList, getCurrentProspect, getMontlyReport, getProspectList, getTrashProspects, listUsers, removeProspect, removeTrashProspects, restoreTrashProspects, updateProspect } from '../redux/slices/prospectsSlice'
import { createProspectSaga, getCurrentProspectSaga, listAllProspectSaga, listAllTrashProspectSaga, listMonthlyProspectSaga, listMyProspectSaga, listUsersForProspects, removeProspectSaga, removeTrashProspectSaga, restoreTrashProspectSaga, syncCurrentProspectSaga } from './sagas/prospectSaga'
import { fetchUserLogs } from '../redux/slices/logsSlice'
import { fetchUserLogsSaga } from './sagas/logsSaga'
import { deleteFile, fileUploaded, replaceFiles, uploadFiles } from '../redux/slices/fileSlice'
import { deleteFileSaga, replaceFileSaga, uploadFileSaga } from './sagas/filesSaga'
import { applyLeave, getAllLeaves, getLeaves, updateLeave } from '../redux/slices/leaveSlice'
import { applyLeaveSaga, getAllLeavesSaga, getEmployeeLeaveBalanceSaga, getLeavesSaga, updateLeaveSaga } from './sagas/leaveSaga'
import { createPayslip, deletePayslip, detailPayslip, getBulkDownloadLinks, getMyPayslip, listPayslip } from '../redux/slices/payslipSlice'
import { createPayslipSaga, deletePayslipSaga, detailsPayslipSaga, getBulkDownloadLinksSaga, listMyPayslipSaga, listPayslipSaga } from './sagas/payslipSaga'
import { deleteReminder, fetchRemainder, fetchReport, updateReminder } from '../redux/slices/remainderSlice'
import { createRemainderSaga, deleteReminderSaga, getRemainderReportSaga, updateReminderSaga } from './sagas/remainderSage'

export function* sagas() {
    yield all([
        takeLatest(fetchDropdown.type, countryDropdownSaga),
        takeLatest(getAddress.type, addressLookupSaga),
        takeLatest(getFinalAddress.type, getAddressSaga),
        takeLatest(createBusinessDescription.type, businessDescriptionSaga),
        takeLatest(getBusinessDescription.type, listDescriptionSaga),
        takeLatest(createBusinessType.type, businessTypeSaga),
        takeLatest(getBusinessType.type, listTypeSaga),
        takeLatest(createAquirer.type, addAquirerSaga),
        takeLatest(listAquirer.type, getAquirerSaga),
        takeLatest(createTerminalType.type, addTerminalTypeSaga),
        takeLatest(listTerminalType.type, getTerminalTypeSaga),
        takeLatest(createTerminalModel.type, addTerminalModelSaga),
        takeLatest(listTerminalModel.type, getTerminalModelSaga),




        takeLatest(login.type, loginUserSaga),
        takeLatest(resetPassword, resetPasswordSaga),
        takeLatest(changePassword.type, changePasswordSaga),
        takeLatest(forceResetPassword.type, forceResetPasswordSaga),




        takeLatest(getUserList.type, listUserSaga),
        takeLatest(getMyProfile.type, fetchMyProfileSaga),
        takeLatest(getUserProfile.type, fetchUserProfileSaga),
        takeLatest(getEmployeeProfile.type, fetchEmployeeProfileSaga),
        takeLatest(updateUser.type, updateUserSaga),
        takeLatest(getEmployeeList.type, listEmployeeSaga),
        takeLatest(updateEmployee.type, updateEmployeeSaga),
        takeLatest(createEmployee.type, createEmployeeSaga),
        takeLatest(getAttendanceList.type, listAttendanceSaga),
        takeLatest(reopenAttendance.type, reopenAttendanceSaga),
        takeLatest(assignEmployeeToTL.type, assignEmployeeToTLSaga),
        takeLatest(employeeLeave.type, createEmployeeLeaveSaga),
        takeLatest(getEmployeeLeave.type, getEmployeeLeaveSaga),
        takeLatest(updateEmployeeLeave.type, updateEmployeeLeaveSaga),
        takeLatest(getUserDashboard.type, fetchUserDashboardSaga),
        takeLatest(changeMyProfilePicture.type, updateMyProfilePictureSaga),
        takeLatest(updateMyProfile.type, updateEmployeeProfileSaga),
        takeLatest(getEmployeeLeaveBalance.type, getEmployeeLeaveBalanceSaga),

        /*******************All SuperAdmin COnversations************ */
        takeLatest(fetchAllConversationUsers.type, getAllConversationsUsersSaga),
        takeLatest(fetchAllMessagesUsers.type, getAllConversationMessagesSaga),





        takeLatest(fetchAllUserConversationList.type, listUsersForConversationSaga),





        /***********************EMERGENCY***************************** */

        takeLatest(createEmergencyContact.type, createEmergencyContactSaga),
        takeLatest(updateEmergencyContact.type, updateEmergencyContactSaga),

        takeLatest(createAttendance.type, createAttendanceSaga),
        takeLatest(todayAttendance.type, getTodayAttendanceSaga),
        takeLatest(listMyAttendance.type, listMyAttendanceSaga),
        takeLatest(closeAttendance.type, closeTodayAttendanceSaga),
        takeLatest(generateMonthlyReport.type, generateMonthlyReportSaga),
        takeLatest(createBreak.type, createBreakSaga),
        takeLatest(closeBreak.type, closeBreakSaga),
        takeLatest(updateAttendanceTime.type, updateAttendanceTimeSaga),
        takeLatest(updateBreakTime.type, updateBreakSaga),




        // all calendar events
        takeLatest(getLeaves.type, getLeavesSaga),
        takeLatest(getAllLeaves.type, getAllLeavesSaga),
        takeLatest(applyLeave.type, applyLeaveSaga),
        takeLatest(updateLeave.type, updateLeaveSaga),
        takeLatest(getCalendarEvent.type, getAllCalendarSaga),
        takeLatest(getRangeEvents.type, getAllCalendarRangeSaga),
        takeLatest(createCalendarEvent.type, createCalendarSaga),
        takeLatest(updateCalendarEvent.type, updateCalenderSaga),
        takeLatest(deleteCalendarEvent.type, deleteCalenderSaga),


        // applications
        takeLatest(saveApplication.type, saveApplicationSaga),
        takeLatest(createApplication.type, createApplicationSaga),
        takeLatest(listApplication.type, listApplicationSaga),
        takeLatest(getStatusCount.type, applicationStatusCountSaga),
        takeLatest(getSingleApplication.type, fetchSingleApplicationSaga),
        takeLatest(updateApplicationStatus.type, updateApplicationStatusSaga),
        takeLatest(assignNewUser.type, assignNewUserSaga),
        takeLatest(updateApplication.type, updateApplicationSaga),
        takeLatest(createPerson.type, createPersonSaga),
        takeLatest(createNotes.type, createNotesSaga),
        takeLatest(fetchNotes.type, fetchNotesSaga),
        takeLatest(fetchLogs.type, fetchLogsSaga),


        // prospects
        takeLatest(createProspects.type, createProspectSaga),
        takeLatest(getProspectList.type, listMyProspectSaga),
        takeLatest(getAllProspectList.type, listAllProspectSaga),
        takeLatest(getCurrentProspect.type, getCurrentProspectSaga),
        takeLatest(updateProspect.type, syncCurrentProspectSaga),
        takeLatest(removeProspect.type, removeProspectSaga),
        takeLatest(listUsers.type, listUsersForProspects),
        takeLatest(getMontlyReport.type, listMonthlyProspectSaga),
        takeLatest(getTrashProspects.type, listAllTrashProspectSaga),
        takeLatest(removeTrashProspects.type, removeTrashProspectSaga),
        takeLatest(restoreTrashProspects.type, restoreTrashProspectSaga),



        // organization ip
        takeLatest(addIp.type, addIpSaga),
        takeLatest(listIp.type, getAllIpSaga),
        takeLatest(updateIp.type, toggleIpSaga),
        takeLatest(removeIp.type, deleteIpSaga),
        takeLatest(createShift.type, addShiftSaga),
        takeLatest(listShifts.type, getAllShiftSaga),
        takeLatest(updateShift.type, udpateShiftSaga),
        takeLatest(getCurrentIp.type, getCurrentIpSaga),


        takeLatest(fetchUserLogs.type, fetchUserLogsSaga),
        takeLatest(uploadFiles.type, uploadFileSaga),
        takeLatest(replaceFiles.type, replaceFileSaga),
        takeLatest(deleteFile.type, deleteFileSaga),


        // payslips
        takeLatest(createPayslip.type, createPayslipSaga),
        takeLatest(listPayslip.type, listPayslipSaga),
        takeLatest(detailPayslip.type, detailsPayslipSaga),
        takeLatest(deletePayslip.type, deletePayslipSaga),
        takeLatest(getMyPayslip.type, listMyPayslipSaga),
        takeLatest(getBulkDownloadLinks.type, getBulkDownloadLinksSaga),


        // remainder
        takeLatest(fetchRemainder.type, createRemainderSaga),
        takeLatest(updateReminder.type, updateReminderSaga),
        takeLatest(deleteReminder.type, deleteReminderSaga),
        takeLatest(fetchReport.type, getRemainderReportSaga),
    ])
}